import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Box,
  Container,
  Divider,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ListItems from "./ListItems";

import Overview from "../../containers/Overview";
import RoomTypes from "../../containers/RoomTypes";
import Addons from "../../containers/Addons";
import Settings from "../../containers/Settings";
import EditAddon from "../../containers/EditAddon";
import NewAddon from "../../containers/NewAddon";
import NewLink from "../../containers/NewLink";
import EditLink from "../../containers/EditLink";

import Promotions from "../../containers/Promotions";
import NewPromotion from "../../containers/NewPromotion";
import EditPromotion from "../../containers/EditPromotion";

import RateNumbers from "../../containers/RateNumbers";
import NewRateNumber from "../../containers/NewRateNumber";
import EditRateNumber from "../../containers/EditRateNumber";

import Gift from "../../containers/Gifts";
import NewGift from "../../containers/NewGift";
import EditGift from "../../containers/EditGift";

import StripeFees from "../../containers/StripeFees";

import Users from "../../containers/Users";
import NewUser from "../../containers/NewUser";
import EditUser from "../../containers/EditUser";

import PendingAudits from "../../containers/PendingAudit";
import ApprovedAudits from "../../containers/ApprovedAudit";
import RejectedAudits from "../../containers/RejectedAudit";

import CreditNotes from "../../containers/CreditNotes";
import NewCreditNote from "../../containers/NewCreditNote";
import EditCreditNote from "../../containers/EditCreditNote";

import ReferralCodes from "../../containers/ReferralCodes";
import NewReferralcode from "../../containers/NewReferralcode";

import SearchAttempts from "../../containers/SearchAttempts";

import Transactions from "../../containers/Transactions";
import ExpiredTransactions from "../../containers/ExpiredTransactions";

import City from "../../containers/City";
import NewCity from "../../containers/NewCity";
import EditCity from "../../containers/EditCity";

import Agents from "../../containers/Agents";
import NewAgent from "../../containers/NewAgent";
import EditAgent from "../../containers/EditAgent";

import Properties from "../../containers/Property";
import NewProperty from "../../containers/NewProperty";
import EditProperty from "../../containers/EditProperty";

import SystemSettings from "../../containers/SystemSettings";
import ReservationSync from "../../containers/ReservationSync";
import LeaseDocuments from "../../containers/LeaseDocuments";
import PromotionRules from "../../containers/PromotionRules";
import ConsentData from "../../containers/ConsentData";
import EditConsentData from "../../containers/EditConsentData";

import { Switch, Route, useHistory, useRouteMatch } from "react-router-dom";
import { AuthContext } from "../../utils/userProvider";

const drawerWidth = 268;
const collapsedWidth = 72;

export default function Dashboard(props) {
  const [open, setOpen] = useState(true);
  const { authState, setAuthState } = useContext(AuthContext);

  const history = useHistory();
  const [title, setTitle] = useState("Overview");
  const { path, url } = useRouteMatch();

  useEffect(() => {
    if (
      props.location.pathname === "/dashboard" ||
      props.location.pathname === "/dashboard/"
    ) {
      history.replace("/dashboard/overview");
      return;
    }

    const pathname = props.location.pathname;
    if (pathname.includes("overview")) setTitle("Overview");
    else if (pathname.includes("roomtypes")) setTitle("Room Types");
    else if (pathname.includes("addons")) setTitle("Add-ons");
    else if (pathname.includes("system-setting")) setTitle("System Settings");
    else if (pathname.includes("settings")) setTitle("Account Settings");
    else if (pathname.includes("expiredTransactions"))
      setTitle("Expired Transactions");
    else if (pathname.includes("transactions")) setTitle("Transactions");
    else if (pathname.includes("promotions")) setTitle("Promotions");
    else if (pathname.includes("rate-numbers")) setTitle("Rate Numbers");
    else if (pathname.includes("gift")) setTitle("Gifts");
    else if (pathname.includes("creditnote")) setTitle("Credit Notes");
    else if (pathname.includes("searchAttempts")) setTitle("Search Attempts");
    else if (pathname.includes("stripefees")) setTitle("Stripe Fees");
    else if (pathname.includes("city")) setTitle("City");
    else if (pathname.includes("agent")) setTitle("Agent");
    else if (pathname.includes("property")) setTitle("Properties");
    else if (pathname.includes("users")) setTitle("Users");
    else if (pathname.includes("pending-audits")) setTitle("Pending Audits");
    else if (pathname.includes("approved-audits")) setTitle("Approved Audits");
    else if (pathname.includes("rejected-audits")) setTitle("Rejected Audits");
    else if (pathname.includes("firstLogin")) setTitle("First Login");
    else if (pathname.includes("consent-data")) setTitle("Consent Data");
    else if (pathname.includes("reservation-sync")) setTitle("Reservation Sync");
    else if (pathname.includes("lease-documents")) setTitle("Lease Documents");
    else if (pathname.includes("referralCodes")) setTitle("Referral Codes");
    else if (pathname.includes("promotion-rules")) setTitle("Promotion Rules");
  }, [props.location, history]);

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  const logout = () => {
    localStorage.clear();
    setAuthState(null);
    window.location.href = "/";
  };

  const go = (segment) => () => history.push(`${url}/${segment}`);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
      <AppBar
        position="fixed"
        color="inherit"
        sx={{
          width: {
            sm: `calc(100% - ${open ? drawerWidth : collapsedWidth}px)`,
          },
          ml: {
            sm: `${open ? drawerWidth : collapsedWidth}px`,
          },
          bgcolor: "#ffffff",
          color: "text.primary",
          transition: (theme) =>
            theme.transitions.create(["width", "margin"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            sx={{ mr: 2, display: open ? "none" : "inline-flex" }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography variant="h6" noWrap component="h1" fontWeight={700}>
              {title}
            </Typography>
            <Typography variant="caption" color="text.secondary" noWrap>
              YSuites Middleware
            </Typography>
          </Box>
          {authState?.name && (
            <Box sx={{ textAlign: "right", display: { xs: "none", md: "block" } }}>
              <Typography variant="body2" fontWeight={600}>
                {authState.name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {authState.role || "User"}
              </Typography>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        open={open}
        sx={{
          width: open ? drawerWidth : collapsedWidth,
          flexShrink: 0,
          whiteSpace: "nowrap",
          "& .MuiDrawer-paper": {
            width: open ? drawerWidth : collapsedWidth,
            boxSizing: "border-box",
            overflowX: "hidden",
            transition: (theme) =>
              theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
          },
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: open ? "space-between" : "center",
            px: open ? 2 : 1,
            minHeight: "64px !important",
            gap: 1,
          }}
        >
          {open && (
            <Box
              component="img"
              src="https://cdn.prod.website-files.com/690daee28e61161bf943fd2c/69128b0778490229e29e3a44_Turquoise%20Long.avif"
              alt="Y Suites"
              sx={{
                height: 28,
                width: "auto",
                maxWidth: 150,
                objectFit: "contain",
                display: "block",
              }}
            />
          )}
          <IconButton onClick={open ? handleDrawerClose : handleDrawerOpen}>
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
        </Toolbar>
        <Divider />
        <ListItems
          open={open}
          logout={logout}
          overview={go("overview")}
          roomTypes={go("roomtypes")}
          addons={go("addons")}
          settings={go("settings")}
          searchAttempts={go("searchAttempts")}
          transactions={go("transactions")}
          promotions={go("promotions")}
          rateNumbers={go("rate-numbers")}
          gifts={go("gifts")}
          referralCodes={go("referralCodes")}
          creditNote={go("creditnote")}
          stripeFees={go("stripefees")}
          expiredTransactions={go("expiredTransactions")}
          city={go("city")}
          agents={go("agent")}
          systemSettings={go("system-setting")}
          reservationSync={go("reservation-sync")}
          leaseDocuments={go("lease-documents")}
          users={go("users")}
          pendingAudits={go("pending-audits")}
          approvedAudits={go("approved-audits")}
          rejectedAudits={go("rejected-audits")}
          properties={go("property")}
          consentData={go("consent-data")}
          path={props.location.pathname}
        />
      </Drawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            sm: `calc(100% - ${open ? drawerWidth : collapsedWidth}px)`,
          },
          minHeight: "100vh",
          overflow: "auto",
        }}
      >
        <Toolbar />
        <Container maxWidth={false} sx={{ py: 3, px: { xs: 2, md: 3 } }}>
          <Switch>
            <Route exact path={`${path}/overview`}>
              <Overview />
            </Route>
            <Route exact path={path}>
              <Overview />
            </Route>
            <Route exact path={`${path}/roomtypes`}>
              <RoomTypes />
            </Route>
            <Route exact path={`${path}/roomtypes/new`}>
              <NewLink />
            </Route>
            <Route path={`${path}/roomtypes/edit/:id`}>
              <EditLink />
            </Route>
            <Route path={`${path}/roomtypes/view/:id`}>
              <EditLink />
            </Route>
            <Route exact path={`${path}/addons`}>
              <Addons />
            </Route>
            <Route path={`${path}/addons/edit/:id`}>
              <EditAddon />
            </Route>
            <Route path={`${path}/addons/view/:id`}>
              <EditAddon />
            </Route>
            <Route exact path={`${path}/addons/new`}>
              <NewAddon />
            </Route>
            <Route exact path={`${path}/transactions`}>
              <Transactions />
            </Route>
            <Route exact path={`${path}/expiredTransactions`}>
              <ExpiredTransactions />
            </Route>
            <Route exact path={`${path}/settings`}>
              <Settings />
            </Route>
            <Route exact path={`${path}/promotions`}>
              <Promotions />
            </Route>
            <Route exact path={`${path}/rate-numbers`}>
              <RateNumbers />
            </Route>
            <Route exact path={`${path}/rate-numbers/new`}>
              <NewRateNumber />
            </Route>
            <Route exact path={`${path}/rate-numbers/edit/:id`}>
              <EditRateNumber />
            </Route>
            <Route exact path={`${path}/rate-numbers/view/:id`}>
              <EditRateNumber />
            </Route>
            <Route exact path={`${path}/promotions/new`}>
              <NewPromotion />
            </Route>
            <Route exact path={`${path}/promotions/edit/:id`}>
              <EditPromotion />
            </Route>
            <Route exact path={`${path}/promotions/view/:id`}>
              <EditPromotion />
            </Route>
            <Route exact path={`${path}/gifts`}>
              <Gift />
            </Route>
            <Route exact path={`${path}/gifts/new`}>
              <NewGift />
            </Route>
            <Route exact path={`${path}/gifts/edit/:id`}>
              <EditGift />
            </Route>
            <Route exact path={`${path}/gifts/view/:id`}>
              <EditGift />
            </Route>
            <Route exact path={`${path}/pending-audits`}>
              <PendingAudits />
            </Route>
            <Route exact path={`${path}/approved-audits`}>
              <ApprovedAudits />
            </Route>
            <Route exact path={`${path}/rejected-audits`}>
              <RejectedAudits />
            </Route>
            <Route exact path={`${path}/creditnote`}>
              <CreditNotes />
            </Route>
            <Route exact path={`${path}/creditnote/new`}>
              <NewCreditNote />
            </Route>
            <Route exact path={`${path}/creditnote/edit/:id`}>
              <EditCreditNote />
            </Route>
            <Route exact path={`${path}/creditnote/view/:id`}>
              <EditCreditNote />
            </Route>
            <Route exact path={`${path}/referralCodes`}>
              <ReferralCodes />
            </Route>
            <Route exact path={`${path}/referralCodes/new`}>
              <NewReferralcode />
            </Route>
            <Route exact path={`${path}/searchAttempts`}>
              <SearchAttempts />
            </Route>
            <Route exact path={`${path}/stripefees`}>
              <StripeFees />
            </Route>
            <Route exact path={`${path}/city`}>
              <City />
            </Route>
            <Route exact path={`${path}/city/new`}>
              <NewCity />
            </Route>
            <Route exact path={`${path}/city/edit/:id`}>
              <EditCity />
            </Route>
            <Route exact path={`${path}/city/view/:id`}>
              <EditCity />
            </Route>
            <Route exact path={`${path}/agent`}>
              <Agents />
            </Route>
            <Route exact path={`${path}/agent/new`}>
              <NewAgent />
            </Route>
            <Route exact path={`${path}/agent/edit/:id`}>
              <EditAgent />
            </Route>
            <Route exact path={`${path}/agent/view/:id`}>
              <EditAgent />
            </Route>
            <Route exact path={`${path}/property`}>
              <Properties />
            </Route>
            <Route exact path={`${path}/property/new`}>
              <NewProperty />
            </Route>
            <Route exact path={`${path}/property/edit/:id`}>
              <EditProperty />
            </Route>
            <Route exact path={`${path}/property/view/:id`}>
              <EditProperty />
            </Route>
            <Route exact path={`${path}/system-setting`}>
              <SystemSettings />
            </Route>
            <Route exact path={`${path}/reservation-sync`}>
              <ReservationSync />
            </Route>
            <Route exact path={`${path}/lease-documents`}>
              <LeaseDocuments />
            </Route>
            <Route exact path={`${path}/promotion-rules`}>
              <PromotionRules />
            </Route>
            <Route exact path={`${path}/consent-data`}>
              <ConsentData />
            </Route>
            <Route exact path={`${path}/consent-data/edit/:id`}>
              <EditConsentData />
            </Route>
            <Route exact path={`${path}/users`}>
              <Users />
            </Route>
            <Route exact path={`${path}/users/new`}>
              <NewUser />
            </Route>
            <Route exact path={`${path}/users/edit/:id`}>
              <EditUser />
            </Route>
          </Switch>
        </Container>
      </Box>
    </Box>
  );
}
